import classnames from 'classnames'
import { useTranslation } from 'next-i18next'

import { PAGE_PATH } from '@src/quince-site-common/src/constants/pageData'
import type { ISubscribedPlan } from '@src/quince-site-common/src/domains/Subscription'

import Image from '../image/Image'
import Link from '../link'
import { ICON_CONSTANTS, ICON_CONSTANTS_MAP } from '../productForm/icon-constants'

import styles from './productSubscriptionDeliveryMessage.module.scss'

export const ProductSubscriptionDeliveryMessageLegacy = ({
  subscribedPlan,
  showNewPdpDesignV2,
  isInStock,
}: {
  subscribedPlan: ISubscribedPlan
  showNewPdpDesignV2: boolean
  isInStock?: boolean
}) => {
  const { t } = useTranslation('common')

  const frequencyDisplayLabel = subscribedPlan?.frequencyDisplayLabel
  if (!frequencyDisplayLabel) return null

  // OOS variants and paused subscriptions don't have a deterministic next
  // shipment — show a neutral "Pending" signal instead of the cadence so
  // shoppers don't assume the next box is already locked in.
  const showPendingDeliveryMessage = !isInStock || subscribedPlan.status === 'PAUSED'
  const deliveryMessage = showPendingDeliveryMessage
    ? `${t('subscribed')}: ${t('next_order_pending')}`
    : `${t('subscribed')}: ${t('ships_every_frequency', { frequency: frequencyDisplayLabel })}`

  return (
    <div
      className={classnames(styles.subscriptionDeliveryMessage, {
        [styles.subscriptionDeliveryMessage_newDesignV2 ?? '']: showNewPdpDesignV2,
      })}
    >
      <div className={styles.contentWrapper}>
        <div className={styles.iconWrapper}>
          <Image
            url={ICON_CONSTANTS_MAP[ICON_CONSTANTS.RECURRING_ICON_BLACK]}
            title={ICON_CONSTANTS.RECURRING_ICON_BLACK}
            alt=""
            className={styles.iconImage}
          />
        </div>
        <p className={styles.text}>{deliveryMessage}</p>
      </div>
      <Link href={`/${PAGE_PATH.MY_SUBSCRIPTIONS}`} className={classnames(styles.manageSubscriptionLink)}>
        {t('manage')}
      </Link>
    </div>
  )
}

export default ProductSubscriptionDeliveryMessageLegacy
